import { theme } from '../../../themes/main';
import { SxStyles } from '../../../types';

export const styles: SxStyles = {
  buttonGroupWrapper: {
    p: { xs: 5, lg: 6 },
  },
  buttonGroupField: {
    gap: 2,
    '.MuiButtonGroup-grouped[aria-checked="false"], .MuiButtonGroup-grouped[aria-checked="true"]': {
      py: 4,
      borderRadius: theme.borderRadius.xs,
      borderWidth: 1,
    },
    '.MuiButtonGroup-grouped[aria-checked="true"]': {
      backgroundColor: theme.palette.green.main,
      borderColor: theme.palette.green.main,
    },
  },
  selectFieldItem: {
    p: { lg: 6 },
  },
};
